module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "ca-team-reports-upsell-illustration.006af92c.png" + "?" + Date.now();